import { cn } from "@/lib/utils";

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "light" | "blue";
}

export const SectionTitle = ({
  children,
  className,
  variant = "default",
}: SectionTitleProps) => {
  const variantStyles = {
    default: "text-text-color",
    light: "text-background",
    blue: "text-primary-blue",
  };

  return (
    <h1
      className={cn(
        "m-0 font-black font-kozuka text-[24px] leading-[150%] lg:text-[60px]",
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </h1>
  );
};
